import { NativeShareResult } from "../models/DocumentExportResult";
import { ensurePdfExtension } from "../utils/documentFileName";
import { validatePdfBlob } from "./documentExportService";

const isShareCancellation = (error: unknown) =>
  error instanceof DOMException
    ? error.name === "AbortError"
    : typeof error === "object" && error !== null && "name" in error && error.name === "AbortError";

export const isNativeShareAvailable = () =>
  typeof navigator !== "undefined" && typeof navigator.share === "function";

export const shareDocument = async (
  blob: Blob,
  options: { fileName: string; title: string; text?: string },
): Promise<NativeShareResult> => {
  if (!isNativeShareAvailable()) return { status: "unsupported" };

  const file = new File([validatePdfBlob(blob)], ensurePdfExtension(options.fileName), {
    type: "application/pdf",
  });

  if (typeof navigator.canShare !== "function" || !navigator.canShare({ files: [file] })) {
    return { status: "unsupported" };
  }

  try {
    await navigator.share({
      title: options.title,
      text: options.text,
      files: [file],
    });
    return { status: "shared" };
  } catch (error) {
    if (isShareCancellation(error)) return { status: "cancelled" };
    throw error;
  }
};
